import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  insuranceSelected: "",
  selectedPlans: [],
  insuranceDeclaration: true,
  totalPlans: 0,
};

export const insuranceSlice = createSlice({
  name: "insurance",
  initialState,
  reducers: {
    setSelectedPlans: (state, action) => {
      state.selectedPlans = action.payload;
      state.insuranceSelected = action.payload.length > 0;
      state.insuranceDeclaration = action.payload.length > 0;
      if (
        Array.isArray(action.payload) &&
        action.payload.length > state.totalPlans
      ) {
        state.totalPlans = action.payload.length;
      }
    },
    setInsuranceDeclaration: (state, action) => {
      state.insuranceDeclaration = action.payload;
    },
    setTotalPlans: (state, action) => {
      state.totalPlans = action.payload.length;
    },
    resetPlans: (state) => {
      state.selectedPlans = [];
      state.insuranceSelected = false;
      state.insuranceDeclaration = false;
    },
  },
});

export const {
  setSelectedPlans,
  setTotalPlans,
  setInsuranceDeclaration,
  resetPlans,
} = insuranceSlice.actions;
export default insuranceSlice.reducer;
